import React from "react"
import { CookieNotice } from "gatsby-cookie-notice"

import Link from 'components/common/link/Link'

import './Cookie.css';
import * as st from './Cookie.styled.js'

const Cookie = () => {
  return (
    <CookieNotice
      backgroundWrapperClasses="cookies__wrap"
      acceptButtonClasses="cookies__primary-button"
      declineButtonClasses="cookies__secondary-button"
      buttonWrapperClasses="cookies__footer"
      personalizeButtonEnable={false}
    >
      <st.Text>
        We use cookies to personalize content, run ads, and analyze traffic. Find out more in
        our&nbsp;<Link
          type="link"
          view="primary"
          size={250}
          href="/legal/privacy/"
        >
          privacy policy
        </Link>.
      </st.Text>
    </CookieNotice>
  )
}

export default Cookie
